import React from 'react';
import useNewBrandContext from 'contexts/new-brand.context';
import { ReactComponent as HexagonIcon } from 'assets/icons/hexagon.svg';
import { Switch, ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';
import { POLYGON_COLORS } from 'utils/constants';

const createBrandPolygon = () => {
  const { createBrandForm, setCreateBrandForm, loadingPolygons } = useNewBrandContext();

  const polygons = createBrandForm.polygon ? createBrandForm.polygon : [];

  if (loadingPolygons) {
    return <p className='p-4 text-gray-500 italic'>Loading polygons...</p>;
  }

  const handleToggle = async (polygonId: string) => {
    const polygonToUpdate = polygons.find((p) => p.id === polygonId);
    if (!polygonToUpdate) return;

    const newAvailable = !polygonToUpdate.available;

    try {
      const updatedLocal = polygons.map((p) =>
        p.id === polygonId ? { ...p, available: newAvailable } : p
      );

      setCreateBrandForm({
        ...createBrandForm,
        polygon: updatedLocal
      });

      toast(<ToastMessage type='success' message={`Updated polygon successfully`} />);
    } catch (error) {
      toast(<ToastMessage type='error' message={`Failed to update polygon`} />);
    }
  };

  return (
    <div>
      {polygons.length > 0 ? (
        <div className='border border-[#EAEAEB] rounded-xl shadow-md overflow-hidden max-w-full sm:w-[500px]'>
          <div className='flex w-full border-b border-[#EAEAEB] font-semibold text-sm bg-pink-50'>
            <div className='flex-1 px-4 py-2 text-gray-5'>POLYGONS</div>
          </div>

          {polygons.map((polygon, index) => (
            <div
              key={polygon.id}
              className={`flex items-center text-sm ${
                index !== polygons.length - 1 ? 'border-b border-[#EAEAEB]' : ''
              }`}>
              <div className='flex-1 flex items-center gap-3 px-4 py-2'>
                <HexagonIcon style={{ color: POLYGON_COLORS[index].color_code }} />
                {polygon.name}
              </div>

              <div className='w-32 px-4 py-4 text-center'>
                <Switch
                  active={polygon.available}
                  disabled={loadingPolygons}
                  onChange={() => handleToggle(polygon.id)}
                />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p>No polygons found for this co-kitchen.</p>
      )}
    </div>
  );
};

export default createBrandPolygon;
